import { PageModuleDataToInsert } from "entities/pages/types";
import { collection, doc, Timestamp, writeBatch } from "firebase/firestore";
import { omit } from "lodash";
import { db } from "shared/api/firebase";

export const bulkCreateModulesByBrandSetting = async (
  brandId: string,
  settingId: string,
  modules: PageModuleDataToInsert[],
): Promise<void> => {
  const batch = writeBatch(db);

  await Promise.all(
    modules.map(async (module) => {
      const collectionRef = collection(
        db,
        `brands/${brandId}/settings/${settingId}/modules`,
      );

      const docRef = doc(collectionRef);

      batch.set(docRef, {
        ...omit(module, ["id"]),
        baseUrl: module.baseUrl ?? "",
        contentBlocks: module.contentBlocks ?? [],
        topPrivacyTipsBlock: null,
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
      });
    }),
  );

  await batch.commit();
};
